import { set } from "../../util/storage";
import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillArticleDB = () => {
    return db.articles.count(async function (count: number) {
        if (count > 0) {
            //console.log("Already populated");
        } else {
            //console.log("Database is empty. Populating from ajax call...");
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticles()
                .then((data) => {

                    //console.log(data)
                    //console.log("Got ajax response. We'll now add the objects.");
                    //console.log("Calling bulkAdd() to insert objects...");
                    if (data) {
                        //set("dbTimestamp", new Date());
                        return db.articles.bulkAdd(data);
                    }
                })
                .then(() => {
                    //console.log("Done populating.");
                    return db.timestamps.add({ name: "articles", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteArticleDatabase = async () => {
    return db.articles.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateArticleDB = async () => {
    await ArticleService.getArticles()
        .then(async (data) => {
            await deleteArticleDatabase().then(() => {
                set("dbTimestamp", new Date());
                //@ts-ignore
                return db.articles.bulkAdd(data);
            })
        })
        .then(() => {
            //console.log("Done refilling.");
            return db.timestamps.put({ name: "articles", timestamp: String(new Date()) })
        })
        .catch(err => console.log(err));
}
